import React, { PropTypes } from 'react';
import DatePicker from 'material-ui/DatePicker';

class LiveDatePicker extends React.Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };

  static contextTypes = {
    intl: PropTypes.object,
    muiTheme: PropTypes.object
  };

  getTextFieldStyle() {
    let {textField} = this.context.muiTheme;

    return {
      border: `solid 1px ${textField.borderColor}`,
      color: textField.textColor,
      fontSize: textField.textSize,
      width: '100%',
      boxSizing: 'border-box',
      padding: 15,
      display: 'flex'
    };
  }

  render() {
    let {onChange, value} = this.props;
    let {intl} = this.context;

    return (
      <DatePicker value={value}
                  onChange={(event, data) => onChange(data)}
                  underlineShow={false}
                  formatDate={(date) => (intl.formatDate(date))}
                  textFieldStyle={this.getTextFieldStyle()}
      />
    );
  }
}

export default LiveDatePicker;




// WEBPACK FOOTER //
// ./src/components/form/LiveDatePicker.js